import {locations} from '@servicenow/ui-internal';
import {getHostVariables} from '../../utils';
import {createMetaData} from './createMetaData';
import {appendToPayload} from './appendToPayload';
import {COMPONENT_ID} from '../../symbols';

export function createEventActionDetails(actionType, host, event, capture, eventHandler) {
	const {detail = {}} = event;
	const {
		type = actionType,
		payload = eventHandler ? appendToPayload(host, {event, host}) : undefined,
		error = null,
		meta = createMetaData(
			host,
			{
				eventHandler,
				capture,
				effectType: locations.EVENT,
				event,
				host,
				get path() {
					return event
						.composedPath()
						.map(el => {
							const hostVariables = getHostVariables(el);
							return hostVariables && hostVariables[COMPONENT_ID];
						})
						.filter(componentId => componentId);
				}
			},
			getHostVariables(host)
		)
	} = detail;

	return {type, payload, error, meta};
}
